import type {
  CaptureConversionTrackingAttributionResponse,
  InitializeConversionTrackingAttributionParams,
} from "@circle-react/api/conversionTrackingApi";
import { conversionTrackingApi } from "@circle-react/api/conversionTrackingApi";
import { createQueryKeyFactory } from "@circle-react/lib/queries/createQueryKeyFactory";
import type { QueryClient } from "react-query";
import { queryOptions } from "react-query";

export type ConversionTrackingAttributionData =
  InitializeConversionTrackingAttributionParams &
    CaptureConversionTrackingAttributionResponse;

const conversionTrackingKey = createQueryKeyFactory("conversion-tracking");

export const conversionTrackingQueryKeys = {
  attribution: () => conversionTrackingKey.key("attribution"),
};

export const conversionTrackingQueries = {
  attribution: ({
    hasEnabledProvider,
    initialData,
    isConsentGranted,
    queryClient,
  }: {
    hasEnabledProvider: boolean;
    initialData: () => ConversionTrackingAttributionData;
    isConsentGranted: boolean;
    queryClient: QueryClient;
  }) =>
    queryOptions({
      queryKey: conversionTrackingQueryKeys.attribution(),
      queryFn: async () => {
        const attributionData =
          queryClient.getQueryData<ConversionTrackingAttributionData>(
            conversionTrackingQueryKeys.attribution(),
          ) ?? initialData();
        const captureResponse =
          await conversionTrackingApi.captureAttribution(attributionData);
        return { ...attributionData, ...captureResponse };
      },
      initialData,
      enabled: isConsentGranted && hasEnabledProvider,
      initialDataUpdatedAt: 0,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 1,
      staleTime: 0,
    }),
};
